<template>
    <v-layout column class="pa-3" style="height: 100%">
        <div v-if="listApiKey.length < 1" class="credential-warning">
            {{$t('noCredentialWarning')}}
            <router-link :to="credentialLink" class="ml-3">{{$t('createCredential')}}</router-link>
        </div>
        <div v-if="apiInfo.name" style="background: #fff;height: 100%" class="pa-3">
            <v-alert :value="true" color="#0052cc" class="mb-3" :dismissible="true" v-if="promotion_text">
                <v-layout align-center>
                    <v-icon color="#fff" class="mr-3">mdi-sale</v-icon>
                    <div v-html="promotion_text"></div>
                </v-layout>
            </v-alert>
            <v-layout align-center row wrap class="pb-4">
                <div class="centerY mr-3">
                    <img :src="apiInfo.icon" alt="icon" class="mr-3">
                    <span class="display-1 ma-0 mr-2" style="color: #707070">{{apiInfo.name}}</span>
                </div>
                <div class="my-3 mr-3" v-if="currentProjectType !== CONST.projectType.POSTPAID">
                    <v-btn
                        :color="apiStatus ? 'warning' : 'primary'"
                        class="ma-0 mr-3 mt-1"
                        @click="toggleAPI"
                    >{{apiStatus ? $t('disable') : $t('enable')}}
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="ma-0 mt-1"
                        @click="openDlPricing()"
                    >{{$t('buy')}}
                    </v-btn>
                </div>
                <div>
                    <div v-if="apiStatus && apiRemain && apiRemain.remain">
                        <div v-if="apiRemain.remain.free && currentProjectType !== CONST.projectType.POSTPAID">
                            {{$t('freeRemain')}}:
                            {{apiRemain.remain.free.remaining | formatNumber}} {{unit}}
                            / {{$t(apiRemain.remain.free.period)}}
                            <span class="ml-3">
                                {{ApiService.getApiUnit(apiInfo.api_code) === 'block' ? `( ${$t('block15s')} )` : ''}}
                            </span>
                        </div>
                        <div v-if="apiRemain.remain.paid">
                            {{$t('paidRemain')}}:
                            {{apiRemain.remain.paid.remaining | formatNumber}} {{unit}}
                        </div>
                    </div>
                </div>
            </v-layout>
            <v-tabs v-model="activeTab" color="rgba(0,0,0,0)" slider-color="#01AFC8">
                <v-tab ripple>{{$t('overview')}}</v-tab>
                <v-tab ripple>{{$t('service')}}</v-tab>
                <v-tab ripple>{{$t('document')}}</v-tab>
                <v-tab ripple>{{$t('pricing')}}</v-tab>
                <v-tabs-items touchless>
                    <v-tab-item key="overview">
                        <iframe :src="getApiLink(apiInfo, 'overview', true)"></iframe>
                    </v-tab-item>
                    <v-tab-item>
                        <div v-if="!apiStatus" class="py-4">{{$t('notEnableForDemo')}}</div>
                        <div v-if="listApiKey.length < 1" class="py-4">
                            {{$t('noCredentialForDemo')}}
                            <v-btn color="primary" @click="createApiKey">Create API Key</v-btn>
                        </div>
                        <template v-if="apiStatus && listApiKey.length > 0">
                            <component :is="DemoMap[apiInfo.api_code]" :parent="this"></component>
                        </template>
                    </v-tab-item>
                    <v-tab-item>
                        <iframe :src="getApiLink(apiInfo, 'document', true)"></iframe>
                    </v-tab-item>
                    <v-tab-item>
                        <iframe :src="getApiLink(apiInfo, 'pricing', true)"></iframe>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
            <ApiPricing :apiCode="apiKeyId" :apiName="apiInfo.name" ref="dlApiPricing"></ApiPricing>
            <PaymentResult ref="dlPaymentResult"></PaymentResult>
        </div>
    </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import ApiService from '@/services/apis.service'
import CredentialsService from '@/services/credentials.service'
import ApiPricing from '@/components/ApiPricing.vue'
import PaymentResult from '@/components/PaymentResult.vue'
import TextToSpeechDemo from './demo/TextToSpeechDemo'
import IDRecognitionDemo from './demo/IDRecognitionDemo'
import SpeechToTextDemo from './demo/SpeechToTextDemo'
import DriverLicenseDemo from './demo/DriverLicenseDemo'
import FaceMatchDemo from '@/views/APIs/demo/FaceMatchDemo'
import PassportRecognitionDemo from '@/views/APIs/demo/PassportRecognitionDemo'
import CreditScoreDemo from '@/views/APIs/demo/CreditScoreDemo'
import LivenessDemo from '@/views/APIs/demo/LivenessDemo'
import ReaderDemo from '@/views/APIs/demo/ReaderDemo'

const DemoMap = {
    [ApiService.ApiCode.SPEECH_TO_TEXT]: SpeechToTextDemo,
    [ApiService.ApiCode.TEXT_TO_SPEECH]: TextToSpeechDemo,
    [ApiService.ApiCode.ID]: IDRecognitionDemo,
    [ApiService.ApiCode.DRIVER_LICENSE]: DriverLicenseDemo,
    [ApiService.ApiCode.FACE_MATCH]: FaceMatchDemo,
    [ApiService.ApiCode.PASSPORT]: PassportRecognitionDemo,
    [ApiService.ApiCode.CREDIT_SCORE]: CreditScoreDemo,
    [ApiService.ApiCode.LIVENESS]: LivenessDemo,
    [ApiService.ApiCode.READER]: ReaderDemo
}

export default {
    name: 'APIKeyDetails',
    components: {
        FaceMatchDemo,
        ApiPricing,
        PaymentResult,
        TextToSpeechDemo,
        IDRecognitionDemo,
        SpeechToTextDemo,
        DriverLicenseDemo,
        PassportRecognitionDemo,
        CreditScoreDemo
    },
    data () {
        let vnPayResponseCode = this.$route.query.vnp_ResponseCode
        if (vnPayResponseCode === '00') {
            this.openDlPaymentResult()
            // this.$appService.toastSuccess(this.$t('transactionSuccess'))
        } else if (vnPayResponseCode && vnPayResponseCode !== '00') {
            this.openDlPaymentResult()
            // this.$appService.toastError(this.$t('transactionFail'))
        }
        return {
            apiInfo: {
                api_code: null,
                name: null,
                icon: null
            },
            apiRemain: {
                remain: {
                    paid: 0
                }
            },
            projectId: this.$route.params.project_id,
            apiKeyId: this.$route.params.apiKeyId,
            credentialLink: `/project/${this.$route.params.project_id}/credentials`,
            objToast: {
                isShowToast: false,
                type: 'success',
                message: ''
            },
            objDialog: {
                isShowDialog: false,
                type: '',
                title: '',
                message: ''
            },
            apiStatus: false,
            activeTab: 1,
            listApiKey: [],
            CONST: this.$const,
            ApiCode: ApiService.ApiCode,
            ApiService: ApiService,
            DemoMap
        }
    },
    computed: {
        ...mapState({
            currentProjectId: state => state.user.currentProjectId
        }),
        currentProjectType () {
            return this.$store.getters.currentProjectType
        },
        unit () {
            let unit = this.$t(ApiService.getApiUnit(this.apiInfo.api_code))
            return this.$appService.getLocale() === 'en' ? unit + 's' : unit
        },
        promotion_text () {
            if (!this.apiInfo.name) {
                return
            }
            let locale = this.$appService.getLocale()
            locale = locale === 'en' ? '' : '_' + locale
            return this.apiInfo['promotion_text' + locale]
        }
    },
    async created () {
        this.$store.dispatch(this.$actionTypes.LOADING, true)
        try {
            // load api status
            const responseAPIStatus = await ApiService.getAPIStatus(this.projectId, this.apiKeyId)
            if (responseAPIStatus) {
                this.apiStatus = responseAPIStatus.enable
            } else {
                this.$appService.toastError(this.$t('canNotLoadApiStatus'))
            }
            // load api info
            let apiInfoResponse = await ApiService.getApiById(this.apiKeyId)
            if (apiInfoResponse.status === 200) {
                this.apiInfo = apiInfoResponse.data
                this.getRemain()
            } else {
                this.$appService.toastError(this.$t('canNotLoadApiInfo'))
            }
            // load api keys
            this.listApiKey = await CredentialsService.getListCredentials(this.currentProjectId)
        } catch (e) {
            this.$appService.toastError(this.$t('error'))
        }
        this.$store.dispatch(this.$actionTypes.LOADING, false)
        // check start tab
        let startTab = this.$route.query.tab
        switch (startTab) {
            case 'overview':
                this.activeTab = 0
                break
            case 'service':
                this.activeTab = 1
                break
            case 'document':
                this.activeTab = 2
                break
            default:
                this.activeTab = 1
        }
    },
    methods: {
        async toggleAPI () {
            ApiService.toggleAPIThenDemo(
                this.currentProjectId,
                {
                    enable: this.apiStatus,
                    id: this.apiKeyId
                },
                apiStatus => {
                    if (apiStatus) {
                        this.apiStatus = apiStatus.enable
                        this.getRemain()
                    }
                }
            )
        },
        async openDlPricing () {
            await this.$refs.dlApiPricing.getApiInfo()
            this.$refs.dlApiPricing.openDialog()
        },
        getApiLink (api, type, isEmb = false) {
            let locale = this.$appService.getLocale()
            locale = locale === 'en' ? '' : '_' + locale
            return api[type + locale] + (isEmb ? '?mode=emb' : '')
        },
        async openDlPaymentResult () {
            this.$refs.dlPaymentResult.openDialog()
        },
        viewApiDocInNewPage (api, type) {
            window.open(this.getApiLink(api, type), '_blank')
        },
        createApiKey () {
            this.$router.push('/project/' + this.currentProjectId + '/credentials')
        },
        getRemain () {
            if (this.apiStatus) {
                ApiService.getRemain(this.currentProjectId, this.apiInfo.id).then(
                    result => {
                        this.apiRemain = result.data
                    }
                ).catch(() => {
                    this.$appService.toastError(this.$t('canNotCheckRemaining'))
                })
            }
        }
    },
    watch: {
        '$route' (val) {
            let tab = val.query.tab
            if (tab) {
                switch (tab) {
                    case 'overview':
                        this.activeTab = 0
                        break
                    case 'service':
                        this.activeTab = 1
                        break
                    case 'document':
                        this.activeTab = 2
                        break
                    default:
                        this.activeTab = 0
                }
            }
        }
    }
}
</script>
<style scoped>
    /deep/ .v-tabs__bar {
        position: relative;
    }

    /deep/ .v-tabs__bar:after {
        position: absolute;
        width: 100%;
        height: 2px;
        background: #01AFC8;
        content: "";
        bottom: 0;
    }

    /deep/ .v-tabs__item--active {
        background: #01AFC8;
        color: #fff;
    }

    .credential-warning {
        padding: 15px 24px;
        margin-bottom: 24px;
        background: #fb8c00;
        color: #fff;
    }

    .api-description /deep/ table td,
    .api-description /deep/ table th {
        padding: 5px;
    }

    iframe {
        width: 100%;
        height: calc(100vh - 369px);
        border: none;
    }
</style>
